import type { SVGProps } from 'react';
export const CenterTextAlignement = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M3 5.65c0-.36.3-.65.68-.65h12.64c.38 0 .68.3.68.65s-.3.65-.68.65H3.68A.67.67 0 0 1 3 5.65m1.72 2.9c0-.36.3-.65.68-.65h9.2c.37 0 .68.3.68.65s-.3.65-.68.65H5.4a.67.67 0 0 1-.68-.65M3 11.45c0-.36.3-.65.68-.65h12.64c.38 0 .68.29.68.65s-.3.65-.68.65H3.68a.67.67 0 0 1-.68-.65m1.72 2.9c0-.36.3-.65.68-.65h9.2c.37 0 .68.29.68.65s-.3.65-.68.65H5.4a.67.67 0 0 1-.68-.65"
      clipRule="evenodd"
    />
  </svg>
);
